
import React from 'react';
 
const HomeComponent = () =>{
return <div>  
     <header>
       <img className='logo' src={require('./bit3logo.png')} />
       </header>
<div className='container'>
   <div className='section'>
      <div className='col-sm-5' >
         <div  >
            <div
               className='title1'> Short Url, Big Response </div>
            <div className='subtitle1'>A URL shortener Tool</div>
         </div>
      </div>
   </div>
</div>
</div>
}

  
export default HomeComponent;